import { __awaiter } from "tslib";
import React from 'react';
import { createStore } from '@souche-f2e/muji';
import Api from '@/services';
import { judgeArr, dealValueShow, thousandBitSeparator, toNumber, judgeEmptyStr, getDataType } from '@/shared/functions';
import { fontEndConfig } from '@/shared/utils';
const initState = {
    show: false,
    showDaYuFooter: false,
    showPayMoney: false,
    modalData: {
        title: '',
        describle: '',
        content: [],
    },
    center: false,
    minKeyLen: 'none',
    style: {},
    className: '',
};
export default createStore({
    state: Object.assign({}, initState),
    effects: {
        /** 加载数据 */
        load(payload, { update, state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                const { type, params, minKeyLen } = payload;
                let data;
                let _minKeyWith;
                if (type === 'daYuDeal') {
                    this.SET_STATE({
                        showDaYuFooter: true,
                    });
                }
                if (type === 'daYuBuyDeal') {
                    this.SET_STATE({
                        showPayMoney: true,
                    });
                }
                switch (type) {
                    case 'buyer':
                        data = yield this.buyerDetailData({ id: params });
                        break;
                    case 'seller':
                        data = yield this.sellerDetailData({ id: params });
                        _minKeyWith = 150;
                        break;
                    case 'dispute':
                        /** @desc 争议原因|违约原因
                         * @argument 4.5 期 增加类型判断，争议原因与违约原因除title外均相同
                         * @param 为了满足之前的需求 即只传一个字符串表示争议原因；
                         * @param 若传对象
                         *        disputeCode属性   string|number
                         *        type属性展示       dispute争议原因|break违约原因，默认展示争议原因
                         */
                        const _param = dealParam(params);
                        if (_param) {
                            data = yield this.disputeReasonData(_param);
                        }
                        else {
                            throw Error('争议原因|违约原因 参数类型不对');
                        }
                        break;
                    case 'daYuDispute':
                        data = yield this.daYudisputeReasonData({ disputeCode: params });
                        break;
                    case 'deal':
                        /** @desc 争议处理详情|违约处理详情
                         * @argument 4.5 期 增加类型判断，争议处理详情 与 违约处理详情 在卖方违约上展示不同
                         * @param 为了满足之前的需求 即只传一个字符串表示争议处理详情；
                         * @param 若传对象
                         *        disputeCode属性   string|number
                         *        type属性展示       dispute争议处理详情|break违约处理详情，默认展示争议处理详情
                         */
                        const _param2 = dealParam(params);
                        if (_param2) {
                            data = yield this.dealDetailData(_param2);
                        }
                        else {
                            throw Error('争议处理详情|违约处理详情 参数类型不对');
                        }
                        break;
                    case 'daYuDeal':
                        data = yield this.daYuDealDetailData({ disputeCode: params });
                        break;
                    case 'daYuBuyDeal':
                        data = yield this.daYuDealDetailDatas({ disputeCode: params });
                        break;
                    case 'pay':
                        data = yield this.payDetailData({ orderId: params });
                        _minKeyWith = 100;
                        break;
                    case 'settle':
                    case 'remit':
                        data = yield this.remitDetailData({ orderId: params });
                        _minKeyWith = 120;
                        break;
                    case 'deposit':
                        data = yield this.depositData({ id: params });
                        break;
                    case 'userDefine':
                        data = params;
                        break;
                    default:
                        console.warn('type类型有误');
                        this.RESET_STATE();
                }
                if (_minKeyWith) {
                    this.SET_STATE({ minKeyLen: _minKeyWith });
                }
                if (!_minKeyWith && minKeyLen === undefined) {
                    this.SET_STATE({ minKeyLen: 'none' });
                }
                if (data && data.title && (judgeArr(data.content) || typeof data.content === 'function')) {
                    this.SET_STATE({ modalData: Object.assign({}, data) });
                    return true;
                }
                return false;
            });
        },
        /**
         * @desc 买家经销商详情
         */
        buyerDetailData(payload) {
            return __awaiter(this, void 0, void 0, function* () {
                const result = {
                    title: '',
                    content: [{ key: '', value: '' }],
                };
                return Api.user.getBuyerDealerDetail(payload).then((res) => {
                    const data = JSON.parse(JSON.stringify(res));
                    result.title = '买家经销商';
                    result.content = [
                        { key: '号码牌', value: dealValueShow(data.numberPlate) },
                        { key: '姓名', value: dealValueShow(data.realname) },
                        { key: '手机号', value: dealValueShow(data.mobile) },
                        { key: '身份证号', value: dealValueShow(data.contactCode) },
                    ];
                    return result;
                }).catch((err) => {
                    console.log(err);
                });
            });
        },
        /**
         * @desc 卖家经销商详情
         */
        sellerDetailData(payload) {
            return __awaiter(this, void 0, void 0, function* () {
                const result = {
                    title: '',
                    content: [{ key: '', value: '' }],
                };
                return Api.user.getSellerDealerDetail(payload).then((res) => {
                    const data = JSON.parse(JSON.stringify(res));
                    result.title = '卖家经销商';
                    result.content = [
                        { key: '集团', value: dealValueShow(data.groupName) },
                        { key: '区域', value: dealValueShow(data.area) },
                        { key: '门店', value: dealValueShow(data.shopName) },
                        { key: '所在地', value: dealValueShow(data.location) },
                        { key: '卖家经销商（姓名）', value: dealValueShow(data.userName) },
                        { key: '联系手机号', value: dealValueShow(data.mobile) },
                    ];
                    return result;
                }).catch((err) => {
                    console.log(err);
                });
            });
        },
        /**
         * @desc 争议原因||违约原因
         */
        disputeReasonData(payload) {
            return __awaiter(this, void 0, void 0, function* () {
                const { disputeCode, type } = payload;
                const typeToValue = {
                    dispute: '争议原因',
                    break: '违约原因',
                };
                const result = {
                    title: '',
                    describle: '',
                    content: [{ key: '', value: '' }],
                };
                return Api.order.getDisputeReason({ disputeCode }).then((res) => {
                    const data = JSON.parse(JSON.stringify(res));
                    result.title = typeToValue[type];
                    result.describle = dealValueShow(data.createTime, '申请');
                    result.content = [
                        { key: '发起方', value: dealValueShow(data.disputeByName) },
                        { key: '争议类型', value: dealValueShow(data.disputeType) },
                        { key: '争议子类型', value: dealValueShow(data.disputeSubType) },
                        { key: '争议原因', value: dealValueShow(data.disputeReason) },
                    ];
                    return result;
                }).catch((err) => {
                    console.log(err);
                });
            });
        },
        daYudisputeReasonData(payload) {
            return __awaiter(this, void 0, void 0, function* () {
                const result = {
                    title: '',
                    describle: '',
                    content: [{ key: '', value: '' }],
                };
                return Api.order.getDisputeReason(payload).then((res) => {
                    const data = JSON.parse(JSON.stringify(res));
                    result.title = '争议原因';
                    result.describle = dealValueShow(data.createTime, '申请');
                    result.content = [
                        { key: '发起方', value: dealValueShow(data.disputeByName) },
                        { key: '争议类型', value: dealValueShow(data.disputeType) },
                        { key: '', value: `扣减金额${dealValueShow(thousandBitSeparator(data.deductionPriceY), '元')}` },
                        { key: '争议子类型', value: dealValueShow(data.disputeSubType) },
                        { key: '争议原因', value: dealValueShow(data.disputeReason) },
                    ];
                    return result;
                }).catch((err) => {
                    console.log(err);
                });
            });
        },
        /**
         * @desc 处理详情
         * @argument 不区分违约处理详情和争议处理详情
         */
        dealDetailData(payload) {
            return __awaiter(this, void 0, void 0, function* () {
                const { disputeCode } = payload;
                const result = {
                    title: '',
                    content: [{ key: '', value: '' }],
                };
                return Api.order.getDisputeOptionDetail({ disputeCode }).then((res) => {
                    const data = JSON.parse(JSON.stringify(res));
                    result.title = '处理详情';
                    result.content = [
                        { key: '处理时间', value: dealValueShow(data.overTime) },
                        { key: '操作人', value: dealValueShow(data.editedBy) },
                        { key: '处理类型', value: dealValueShow(data.disputeResult.replace(/(^\s*)|(\s*$)/g, '')) },
                        { key: '处理结果备注', value: dealValueShow(data.disputeRemark) },
                    ];
                    let addCol;
                    /**
                     * @desc disputeResultCode [string]: 争议或者违约code码 0:买家违约  1:卖家违约   2:交易继续   3:流拍   10:买家违约   11:卖家违约    12:取消交易
                     */
                    switch (data.disputeResultCode) {
                        case '0':
                        case '1':
                        case '10':
                        case '11':
                            addCol = { key: '违约扣款', value: dealValueShow(data.breachPriceY, '元') };
                            break;
                        case '2':
                            addCol = {
                                key: '买家费用减免',
                                value: data.recStatus === 0 ?
                                    `减免服务费${data.reductionServiceY || ''} 元，
              减免佣金${data.reductionCommissionY || ''} 元，
              减免车款${data.reductionCarPriceY || ''} 元`
                                    : `减免车款${data.reductionCarPriceY || ''} 元`,
                            };
                            break;
                    }
                    addCol ? result.content.splice(3, 0, addCol) : '';
                    return result;
                }).catch((err) => {
                    console.log(err);
                });
            });
        },
        /**
         * @desc 处理详情卖家 ---大域
         */
        daYuDealDetailData(payload) {
            return __awaiter(this, void 0, void 0, function* () {
                const result = {
                    title: '',
                    content: [{ key: '', value: '' }],
                };
                return Api.order.daYuDisputeManage(payload).then((res) => {
                    if (res) {
                        const data = JSON.parse(JSON.stringify(res));
                        result.title = '处理详情';
                        result.content = [
                            { key: '处理时间', value: dealValueShow(data.overTime) },
                            { key: '操作人', value: dealValueShow(data.editedBy) },
                            { key: '处理类型', value: dealValueShow(data.disputeResult) },
                            { key: '', value: `扣减金额${dealValueShow(thousandBitSeparator(data.deductionPriceY), '元')}` },
                            { key: '处理说明', value: dealValueShow(data.disputeRemark) },
                        ];
                        return result;
                    }
                }).catch((err) => {
                    console.log(err);
                });
            });
        },
        /**
        * @desc 处理详情买家 ---大域
        */
        daYuDealDetailDatas(payload) {
            return __awaiter(this, void 0, void 0, function* () {
                const result = {
                    title: '',
                    content: [{ key: '', value: '' }],
                };
                return Api.order.daYuDisputeManage(payload).then((res) => {
                    if (res) {
                        const data = JSON.parse(JSON.stringify(res));
                        const payMoney = `赔付${dealValueShow(thousandBitSeparator(data.compensationPriceY), '元')}`;
                        const disputeCode = Number(data.disputeResultCode);
                        const disputeResult = data.disputeResult;
                        result.title = '处理详情';
                        result.content = [
                            { key: '处理时间', value: dealValueShow(data.overTime) },
                            { key: '操作人', value: dealValueShow(data.editedBy) },
                            { key: '处理类型', value: (disputeCode === 0) ? payMoney : disputeResult },
                            { key: '处理说明', value: dealValueShow(data.disputeRemark) },
                        ];
                        return result;
                    }
                }).catch((err) => {
                    console.log(err);
                });
            });
        },
        /**
         * @desc 付款明细
         */
        payDetailData(payload) {
            return __awaiter(this, void 0, void 0, function* () {
                const result = {
                    title: '',
                    content: [{ key: '', value: '' }],
                };
                return Api.finance.payDetail(payload).then((res) => {
                    const data = JSON.parse(JSON.stringify(res));
                    result.title = '付款明细查看';
                    let _sub;
                    switch (data.changeType) {
                        case 1:
                            _sub = `增加${data.changePriceY} 元`;
                            break;
                        case 2:
                            _sub = `扣减${data.changePriceY} 元`;
                            break;
                        default: // 0:无
                            _sub = '无';
                    }
                    result.content = [
                        { key: '付款金额', value: dealValueShow(thousandBitSeparator(data.receivePriceY), '元') },
                        // { key: '增减金额', value: _sub },
                        // { key: '实际付款金额', value: `${data.frPriceY} 元` },
                        { key: '方式', value: dealValueShow(data.receiveFormString) },
                        { key: '转账流水', value: dealValueShow(data.tradeNum) },
                        { key: '备注', value: dealValueShow(data.remark) },
                    ];
                    const contentLen = result.content.length;
                    if (data.receiveForm === 1 || data.receiveForm === 4) {
                        result.content.splice(contentLen - 2, 1);
                    }
                    return result;
                }).catch((err) => {
                    console.log(err);
                });
            });
        },
        /**
         * @desc 打款明细 结算情况详情
         */
        remitDetailData(payload) {
            return __awaiter(this, void 0, void 0, function* () {
                const result = {
                    title: '',
                    content: [{ key: '', value: '' }],
                };
                return Api.finance.remitDetail(payload).then((res) => {
                    const data = JSON.parse(JSON.stringify(res));
                    result.title = '打款明细查看';
                    if (judgeArr(data)) {
                        // 应打款金额
                        const _shouldPay = data[0].totalPriceY;
                        let _realPay = '';
                        let _subMoney = '';
                        const _payWay = [];
                        const _payRecord = [];
                        let _payRemark = [];
                        for (const [i, elem] of data.entries()) {
                            // 实际打款金额
                            _realPay = judgeEmptyStr(elem.fpPriceY) ? toNumber(_realPay) + toNumber(elem.fpPriceY) : _realPay;
                            // 扣减金额
                            elem.changeType === 2 ? _subMoney = toNumber(_subMoney) + toNumber(elem.changePriceY) : '';
                            // 支付方式
                            if (_payWay.findIndex(n => n === elem.payFormString) === -1) {
                                _payWay.push(elem.payFormString);
                            }
                            // 打款记录
                            const _pRc = {
                                w: dealValueShow(elem.payFormString),
                                m: dealValueShow(thousandBitSeparator(elem.payPriceY), '元'),
                                t: dealValueShow(elem.createTime),
                            };
                            elem.payForm === 3 ? _pRc.d = dealValueShow(elem.tradeNum) : '';
                            _payRecord.push(_pRc);
                            // 备注
                            if (elem.remark) {
                                const _pRm = {
                                    m: dealValueShow(elem.remark),
                                    t: dealValueShow(elem.createTime),
                                };
                                _payRemark.push(_pRm);
                            }
                        }
                        judgeArr(_payRemark) ? _payRemark = _payRemark.map((_item, i) => {
                            _item.w = `备注${i + 1}`;
                            return _item;
                        }) : '';
                        // 处理打款记录和备注
                        const _r = (data, styleType) => (<div>
              {judgeArr(data) && data.map((_d, _i) => (<div key={`info_pay_record_${_i}`} className="flex__row-startS" style={_i === data.length - 1 ? {} : { marginBottom: 10 }}>
                    <div style={{ flex: 2.5 }}>
                      {_d.w}
                    </div>
                    {styleType === 0 &&
                            <div style={{ flex: 8 }}>
                        <div style={{ float: 'left' }}>
                          {_d.m}
                        </div>
                        <div style={{ float: 'right' }}>
                          {_d.t}
                        </div>
                        <br />
                        {_d.d && `流水号：${_d.d}`}
                      </div>}
                    {styleType === 1 &&
                            <>
                        <div style={{ flex: 3.5 }}>
                          {_d.m}
                        </div>
                        <div style={{ flex: 4.5 }}>
                          {_d.t}
                        </div>
                      </>}
                  </div>))}
              {!judgeArr(data) && '--'}
            </div>);
                        // 展示数据
                        result.content = [
                            { key: '应打款金额', value: dealValueShow(thousandBitSeparator(_shouldPay), '元') },
                            { key: '扣减金额', value: dealValueShow(thousandBitSeparator(_subMoney), '元', '无') },
                            { key: '实际打款金额', value: dealValueShow(thousandBitSeparator(_realPay), '元') },
                            { key: '方式', value: judgeArr(_payWay) ? _payWay.join('，') : fontEndConfig.noValueReplace },
                            { key: '打款记录', value: judgeArr(_payRecord) ? _r(_payRecord, 0) : fontEndConfig.noValueReplace },
                            { key: '备注', value: judgeArr(_payRemark) ? _r(_payRemark, 1) : fontEndConfig.noValueReplace },
                        ];
                    }
                    return result;
                }).catch((err) => {
                    console.log(err);
                });
            });
        },
        /**
         * @desc 保证金退款查看
         */
        depositData(payload) {
            return __awaiter(this, void 0, void 0, function* () {
                const result = {
                    title: '',
                    content: [{ key: '', value: '' }],
                };
                return Api.finance.depositDetail(payload).then((res) => {
                    const data = JSON.parse(JSON.stringify(res));
                    result.title = '查看';
                    result.content = [
                        { key: '退款金额', value: dealValueShow(thousandBitSeparator(data.moneyY), '元') },
                        { key: '方式', value: dealValueShow(data.withdrawType) },
                        { key: '流水号', value: dealValueShow(data.paySerial) },
                    ];
                    const contentLen = result.content.length;
                    if (data.withdrawType === '现金' || data.withdrawType === '其他') {
                        result.content.splice(contentLen - 1, 1);
                    }
                    return result;
                }).catch((err) => {
                    console.log(err);
                });
            });
        },
        /** 处理showInfo props */
        show(payload, { update, state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                // 处理center，minKeyLen
                const { center, minKeyLen, style, className } = payload;
                if (center !== undefined || minKeyLen !== undefined || style !== undefined || className !== undefined) {
                    this.SET_STATE({
                        center: center !== undefined ? !!center : false,
                        minKeyLen: minKeyLen !== undefined ? minKeyLen : 'none',
                        style,
                        className,
                    });
                }
                const _r = yield this.load(payload);
                _r ? this.SHOW() : '';
            });
        },
    },
    reducers: {
        RESET_STATE() {
            return Object.assign({}, initState);
        },
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                if (initState[key] !== undefined) {
                    state[key] = payload[key];
                }
            });
        },
        RESET_HIDE(state) {
            state.show = false;
            state.showDaYuFooter = false;
        },
        SHOW(state, payload) {
            state.show = true;
        },
    },
});
/** 处理争议|违约的 原因|处理详情 参数 */
function dealParam(payload) {
    if (['string', 'number'].includes(typeof (payload))) {
        return { disputeCode: payload, type: 'dispute' };
    }
    if (getDataType(payload) === 'Object') {
        const { disputeCode, type } = payload;
        const hasDisputeCodeProp = payload.hasOwnProperty('disputeCode');
        const hasTypeProp = payload.hasOwnProperty('type');
        return hasDisputeCodeProp ?
            hasTypeProp ?
                ['dispute', 'break'].includes(type) ? { disputeCode, type } : { disputeCode, type: 'dispute' }
                : { disputeCode, type: 'dispute' }
            : false;
    }
    return false;
}
